import { ApplicationPrefix } from '@openx/constants/paths.ts';
import { isPathInApp } from '../../lib/isPathInApp.ts';

type RollbarSettings = {
  accessToken: string;
};

export type RollbarAppName = 'Unity' | 'Publisher' | 'Dsp' | 'Dispatcher' | 'CTA';

export const AppNames = {
  Unity: 'Unity',
  Publisher: 'Publisher',
  Dsp: 'Dsp',
  Dispatcher: 'Dispatcher',
  Cta: 'CTA',
} as const;

const getAppName = (appName?: RollbarAppName) => {
  const pathname = new URL(window.location.href).pathname;

  if (appName) {
    return appName;
  }

  if (isPathInApp(pathname, ApplicationPrefix.Unity)) {
    return AppNames.Unity;
  }

  if (isPathInApp(pathname, ApplicationPrefix.Publisher)) {
    return AppNames.Publisher;
  }

  if (isPathInApp(pathname, ApplicationPrefix.Dsp)) {
    return AppNames.Dsp;
  }

  return AppNames.Dispatcher;
};

const rollbarSettingsByApp = {
  [AppNames.Unity]: {
    accessToken: '49d40bed34f64c28820e5f620b0c1fde',
  },
  [AppNames.Publisher]: {
    accessToken: '50101161c6424a198e530b75b1ead64b',
  },
  [AppNames.Dsp]: {
    accessToken: 'ee8767ab42894bdc9d4d85992dd0d3a3',
  },
  [AppNames.Dispatcher]: {
    accessToken: '7677d366f4b9416abbee4985867dafa5',
  },
  [AppNames.Cta]: {
    accessToken: '07ded9dee6b447f187afbc9b0f1d8696',
  },
};

export const getRollbarSettingsByApp = (appName?: RollbarAppName): RollbarSettings => {
  const rollbarAppName = appName || getAppName();

  return rollbarSettingsByApp[rollbarAppName];
};
